import { Envelope, GeoBounded } from "./geography.envelope";
export class GeoBoundedCollection extends GeoBounded {
    constructor() {
        super();
        this._items = new Array();
    }
    push(...views) {
        this._items.push(...views);
        this.invalidateEnvelope();
    }
    findIndex(predicate, thisArg) {
        return this._items.findIndex(predicate, thisArg);
    }
    splice(start, deleteCount) {
        this._items.splice(start, deleteCount);
        this.invalidateEnvelope();
    }
    [Symbol.iterator]() {
        let pointer = 0;
        let items = this._items;
        const iterator = {
            next() {
                if (pointer < items.length) {
                    return {
                        done: false,
                        value: items[pointer++],
                    };
                }
                return {
                    done: true,
                    value: null,
                };
            },
            [Symbol.iterator]() {
                return this;
            },
        };
        return iterator;
    }
    _buildEnvelope() {
        return Envelope.FromEnvelopes(...this._items.map((v) => v.geoBounds));
    }
}
//# sourceMappingURL=geography.envelope.collection.js.map